import { PolicyInsightsConfig } from '../../../../types/policies';
import { apiGet } from '../../../../api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { policyInsightsQueryKeys } from '../constants/queryKeys';

type PolicyInsightsConfigDto = PolicyInsightsConfig;

const fetchPolicyInsightsConfig = async (): Promise<PolicyInsightsConfigDto> => {
    const data = await apiGet<PolicyInsightsConfigDto>(`policies/insights/config`);
    return data;
};

export const usePolicyInsightsConfig = (): UseQueryResult<PolicyInsightsConfig> => {
    return useQuery({
        queryKey: policyInsightsQueryKeys.insightsConfig(),
        queryFn: fetchPolicyInsightsConfig
    });
};
